<template>
  <div class="CalendarWrap clearfix">
    <div class="LeftContent">
      <div class="Month">
        <p>{{ month[Month - 1] }}</p>
        <p>{{ Month }}</p>
      </div>
      <div class="Tip">
        <p>今日提醒</p>
        <p>
          <span>{{ num || 0 }}</span
          >条
        </p>
      </div>
    </div>
    <div class="RightContent">
      <div id="CldFrame">
        <div class="CldBody">
          <table>
            <thead>
              <tr class="Week">
                <td style="color: #d65d50;font-weight: bold;">Su</td>
                <td>Mo</td>
                <td>Tu</td>
                <td>Th</td>
                <td>We</td>
                <td>Fr</td>
                <td>Sa</td>
              </tr>
            </thead>
            <tbody id="Tbody">
              <tr v-for="(week, weekIndex) in showDays" :key="weekIndex">
                <td
                  :class="date.isTotay ? 'curDate' : 'isDate'"
                  v-for="(date, index) in week"
                  :key="index"
                >
                  {{ date.value }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    name: 'calendar',
    components: {},
    /*    props: {
      num: [String, Number],
      Year: [String, Number],
      Month: [String, Number]
    }, */
    data () {
      return {
        Year: '',
        Month: '',
        monthDay: [31, 0, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31],
        showDays: [],
        currentDate: new Date(),
        tbody: '',
        weeks: ['Su', 'Mo', 'Tu', 'Th', 'We', 'Fr', 'Sa'],
        month: [
          'Jan',
          'Feb',
          'Mar',
          'Apr',
          'May',
          'Jun',
          'Jul',
          'Aug',
          'Sep',
          'Oct',
          'Nov',
          'Dec'
        ]
      };
    },
    watch: {
      Year (val) {
        if (val) {
          console.log(val);
          if (this.isLeap(val)) {
            this.monthDay[1] = 29;
          } else {
            this.monthDay[1] = 28;
          }
          this.showCld(
            this.Year,
            this.Month,
            this.whatDay(this.Year, this.Month)
          );
        }
      }
    },
    mounted () {
      let curDate = new Date();
      this.Year = curDate.getFullYear();
      this.Month = curDate.getMonth() + 1;
    },
    methods: {
      /*
       * 判断闰年
       */
      isLeap (year) {
        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
      },
      whatDay (year, month, day = 1) {
        return new Date(year + '-' + month + '-' + day).getDay();
      },
      showCld (year, month, firstDay) {
        let i;
        let days = this.monthDay[month - 1];

        let date = [];
        for (i = 0; i < firstDay; i++) {
          date.push({ value: '' });
        }

        for (i = 1; i <= days; i++) {
          date.push({
            value: i,
            dateTime: new Date(year + '-' + month + '-' + i).getTime(),
            dateStr: new Date(year + '-' + month + '-' + i).toString(),
            isTotay:
              year === this.currentDate.getFullYear() &&
              month === this.currentDate.getMonth() + 1 &&
              i === this.currentDate.getDate()
          });
        }
        // if (date.length % 7 !== 0) {
        //   for (i = date.length % 7; i < 7; i++) {
        //     date.push({ value: "" });
        //   }
        // }
        // for (i = 0; i < date.length / 7; i++) {
        //   this.showDays.push(date.slice(i * 7, (i + 1) * 7));
        // }
        while (date.length > 0) {
          this.showDays.push(date.splice(0, 7));
        }
      }
    }
  };
</script>
<style lang="scss">
@import '../../public/Value';
.CalendarWrap {
  width: 100%;
  height: 100%;
  .LeftContent {
    width: 0.35rem;
    height: 0.9rem;
    float: left;
    position: relative;
    .Tip {
      position: absolute;
      bottom: 0.04rem;
      left: 0.08rem;
      opacity: 0.8;
      p {
        line-height: normal;
      }
      p:first-child {
        font-size: $SmallTextSize;
        color: #fff;
      }
      p:last-child {
        span {
          font-size: $NumTitleSize;
          font-weight: bold;
        }
        color: #fff;
        font-size: $SmallTextSize;
      }
    }
    .Month {
      margin-top: 0.08rem;
      margin-left: 0.08rem;
      opacity: 0.8;
      p {
        line-height: normal;
      }
      p:first-child {
        font-size: $TextSize;
        color: #fff;
      }
      p:last-child {
        font-size: $NumTitleSize;
        font-weight: bold;
        color: #fff;
      }
    }
  }
  .RightContent {
    width: 1rem;
    height: 100%;
    float: right;
  }
}
#CldFrame {
  position: relative;
  width: 100%;
  .CldBody {
    width: 0.95rem;
    height: 0.85rem;
    margin: 0.08rem 0 0;
    color: #fff;
    table {
      width: 100%;
      height: 100%;
      font-size: $SmallTextSize;
      color: #fff;
      thead {
        margin-bottom: 0.02rem;
        .Week {
          text-align: center;
          font-size: $TextSize;
          color: #c8c9c9;
          td {
            padding: 0 0 0.01rem;
            width: 0.05rem;
          }
        }
      }
      tbody {
        text-align: center;
        td:first-child {
          color: #d65d50;
          font-weight: bold;
        }
        .curDate {
          border-bottom: 2px solid #db6457;
        }
      }
    }
  }
}
</style>
